<header class="baymax-header"
    [ngClass]="{'is-modal': isModal, 'is-not-modal': !isModal}"
    dclStickyBar
    [isBarInModal]="isModal"
    [container]="parent"
    [animationDelay]="animationDelay">
    <!-- CLOSE BUTTON -->
    <button *ngIf="isCloseBtn" class="dcl-link close-button" (click)="onIconClick()">
        <i class="close-icon di di-close-reversed">
            <span class="sr-only">{{ 'close-button.close' | translate }}</span>
        </i>
    </button>
    <!-- BACK BUTTON -->
    <button *ngIf="!isCloseBtn" class="dcl-link back-button" (click)="onIconClick()">
        <i class="back-icon di di-previous">
            <span class="sr-only">{{ 'back-button.back-button' | translate }}</span>
        </i>
    </button>
    <h3 class="baymax-header-title" [innerHtml]="title | translate"></h3>
</header>
